export default __webpack_public_path__ + "static/media/StarOutlined.6b1926af.svg";